// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const icons = {
    IconDashboard: IconDashboard,
    IconDeviceAnalytics
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'dashboard',
    title: 'Analytics',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Portfolios',
            type: 'item',
            url: '/dashboard',
            icon: icons['IconDashboard'],
            breadcrumbs: false
        },
        {
            id: 'markets',
            title: 'Markets',
            type: 'item',
            url: '/markets',
            icon: icons['IconDeviceAnalytics'],
            breadcrumbs: false
        }
    ]
};
